import { createSelector } from "reselect";
import { get } from "lodash";
import { ScheduledOfferingState } from "store/rootReducer";

const getScheduledOfferingList = (state: ScheduledOfferingState) =>
  get(state, "scheduledOffering.ScheduledOfferingList");

const getEnroledStudentList = (state: ScheduledOfferingState) =>
  get(state, "scheduledOffering.EnroledStudentList");

export const getScheduledOfferingListSelector = createSelector(
  getScheduledOfferingList,
  (list) => list
);

export const getEnroledStudentListSelector = createSelector(
  getEnroledStudentList,
  (list) => list
);

const handleSaveAttendanceChange = (state: ScheduledOfferingState) =>
  get(state, "scheduledOffering.isSaveAttendance");

export const isSaveAttendanceClickSelector = createSelector(
  handleSaveAttendanceChange,
  (prev) => prev
);

const handleMaxEnrolmentChange = (state: ScheduledOfferingState) =>
  get(state, "scheduledOffering.isMaxEnrolmentChange");

export const isMaxEnrolmentChangeSelector = createSelector(
  handleMaxEnrolmentChange,
  (prev) => prev
);

const handleSaveGenerateCertificateChange = (state: ScheduledOfferingState) =>
  get(state, "scheduledOffering.isSaveCertificate");

export const isSaveGenerateCertificateSelector = createSelector(
  handleSaveGenerateCertificateChange,
  (prev) => prev
);
